import * as React from 'react';
var document = globalThis.document;
var meta = document === null || document === void 0 ? void 0 : document.querySelector('meta[name="description"]');
var defaultDescription = meta === null || meta === void 0 ? void 0 : meta.getAttribute('content');
var defaultTitle = document === null || document === void 0 ? void 0 : document.title;
export var Page = function (_a) {
    var title = _a.title, description = _a.description, children = _a.children;
    React.useEffect(function () {
        if (document) {
            document.title = title || defaultTitle;
        }
    }, [title]);
    React.useEffect(function () {
        meta === null || meta === void 0 ? void 0 : meta.setAttribute('content', description || defaultDescription);
    }, [description]);
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=index.js.map